import { FILTER_KEYS } from '@atlassian/mpac-utils';
import { isPlainObject } from '@atlassian/mpac-utils/object';
import { HostingTypes as SearchHostingTypeFilter } from '../../SearchFilters/Filters/HostingFilters';
import { filtersMap, RUNS_ON_ATLASSIAN_FILTER_ID } from './FiltersMap';
/**
 * Transforms filter request params for search service API call
 */
export const transformFiltersForNlpSearch = (filters, environment) => {
  var _filters$product, _filters$hosting, _filters$hosting2;
  const searchFilters = {};
  const tagsCategories = [];
  const tagsKeywords = [];

  // Transform each filter option
  Object.entries(filters).forEach(_ref => {
    let [filterId, filterOptions] = _ref;
    const filterOptionsValue = Array.isArray(filterOptions) ? filterOptions : [filterOptions];
    filterOptionsValue.forEach(filterOption => {
      if (filterId === FILTER_KEYS.HOSTING && filterOption.id === SearchHostingTypeFilter.ISOLATED_CLOUD) {
        searchFilters.runsOnAtlassianStatus = RUNS_ON_ATLASSIAN_FILTER_ID(environment);
      } else if (filterId === FILTER_KEYS.CATEGORIES) {
        tagsCategories.push(filterOption.value);
      } else if (filterId === FILTER_KEYS.USE_CASES) {
        tagsKeywords.push(filterOption.value);
      } else if (isPlainObject(filtersMap[filterId])) {
        if (filterOption.id === FILTER_KEYS.RUNS_ON_ATLASSIAN) {
          searchFilters.runsOnAtlassianStatus = RUNS_ON_ATLASSIAN_FILTER_ID(environment);
        } else {
          searchFilters[filtersMap[filterId][filterOption.id]] = filterOption.value;
        }
      } else {
        searchFilters[filtersMap[filterId]] = filterOption.value;
      }
    });
  });
  return {
    parentApplicationKey: filters === null || filters === void 0 ? void 0 : (_filters$product = filters.product) === null || _filters$product === void 0 ? void 0 : _filters$product[0].value,
    cloudFortifiedStatus: searchFilters['programs.cloudFortified.status'],
    bugBountyParticipantStatus: searchFilters['programs.bugBountyParticipant.cloud.status'] === 'bugBountyApproved' ? 'approved' : undefined,
    runsOnAtlassianStatus: searchFilters.runsOnAtlassianStatus,
    partnerSupported: searchFilters['version.supported'],
    paid: searchFilters['version.paid'],
    stable: searchFilters['version.stable'],
    freeStarterTierStatus: searchFilters.freeStarterTierStatus,
    /**
     * The IC option is part of hosting filter in UI but since it is passed as runsOnAtlassianStatus tag,
     * it cannot be passed in hosting also. Hence if it is selected in any case,
     * hosting key is marked as undefined & runsOnAtlassianStatus key is populated.
     */
    hosting: (filters === null || filters === void 0 ? void 0 : (_filters$hosting = filters.hosting) === null || _filters$hosting === void 0 ? void 0 : _filters$hosting[0].id) !== SearchHostingTypeFilter.ISOLATED_CLOUD ? filters === null || filters === void 0 ? void 0 : (_filters$hosting2 = filters.hosting) === null || _filters$hosting2 === void 0 ? void 0 : _filters$hosting2[0].value : undefined,
    tagsCategories: tagsCategories.length > 0 ? tagsCategories : undefined,
    tagsKeywords: tagsKeywords.length > 0 ? tagsKeywords : undefined
  };
};

/**
 * Transforms sort request params for search service API call
 */
export const transformSortForNlpSearch = function transformSortForNlpSearch() {
  var _sortMappings$sortKey;
  let sortKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const defaultSort = {
    field: 'relevance'
  };
  const sortMappings = {
    newest: {
      field: 'releaseDate'
    },
    topSelling: {
      field: 'recentGrossTotal'
    },
    trending: {
      field: 'deltaInstalls'
    },
    topRated: {
      field: 'ratingsScore'
    }
  };
  return ((_sortMappings$sortKey = sortMappings[sortKey]) === null || _sortMappings$sortKey === void 0 ? void 0 : _sortMappings$sortKey.field) || defaultSort.field;
};